import { MonitoringRequestTypes } from './types';

interface GetElectronicsTradingsParams {
  companyId: number;
  companyIds?: number[];
  page?: number;
  source_id?: number[];
  filtered_by?: string;
  search?: string | null;
  filter_type?: string;
}

export const getMonitoringStatus = (companyId: number) => ({
  types: [
    MonitoringRequestTypes.STATUS_MONITORING_REQUEST,
    MonitoringRequestTypes.STATUS_MONITORING_SUCCESS,
    MonitoringRequestTypes.STATUS_MONITORING_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/facilitadores/monitoramento.json', {
      params: { companyId },
    }),
});

export const getElectronicsTradings = (params: GetElectronicsTradingsParams) => {
  const {
    companyId,
    companyIds,
    page = 1,
    source_id = [],
    search,
    filtered_by = 'by_me',
    filter_type,
  } = params;
  return {
    types: [
      MonitoringRequestTypes.ELECTRONICS_TRADINGS_REQUEST,
      MonitoringRequestTypes.ELECTRONICS_TRADINGS_SUCCESS,
      MonitoringRequestTypes.ELECTRONICS_TRADINGS_FAILURE,
    ],
    rest: { filter_type },
    promise: (client: any) =>
      client.get('/facilitadores/electronics_trading.json', {
        params: {
          page,
          source_id,
          filtered_by,
          search,
          companyId,
          company_ids: companyIds,
          filter_type,
        },
      }),
  };
};

export const getElectronicTrading = (electronic_trading_id: number) => ({
  types: [
    MonitoringRequestTypes.ELECTRONIC_TRADING_REQUEST,
    MonitoringRequestTypes.ELECTRONIC_TRADING_SUCCESS,
    MonitoringRequestTypes.ELECTRONIC_TRADING_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/facilitadores/electronics_trading/${electronic_trading_id}`),
});

export const destroyElectronicsTradings = (biddingId: number, companyId: number) => ({
  types: [
    MonitoringRequestTypes.DESTROY_ELECTRONICS_TRADINGS_REQUEST,
    MonitoringRequestTypes.DESTROY_ELECTRONICS_TRADINGS_SUCCESS,
    MonitoringRequestTypes.DESTROY_ELECTRONICS_TRADINGS_FAILURE,
  ],
  biddingId,
  promise: (client: any) =>
    client.delete(`/facilitadores/monitoramento/${biddingId}`, { params: { companyId } }),
});

export const getTradingMessages = (electronicTradingId: number) => ({
  types: [
    MonitoringRequestTypes.TRADING_MESSAGES_REQUEST,
    MonitoringRequestTypes.TRADING_MESSAGES_SUCCESS,
    MonitoringRequestTypes.TRADING_MESSAGES_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/facilitadores/trading_messages.json?electronic_trading_id=${electronicTradingId}`),
});

export const getInterestLots = (electronicTradingId: number, companyId: number) => ({
  types: [
    MonitoringRequestTypes.INTEREST_LOTS_REQUEST,
    MonitoringRequestTypes.INTEREST_LOTS_SUCCESS,
    MonitoringRequestTypes.INTEREST_LOTS_FAILURE,
  ],
  rest: electronicTradingId,
  companyId,
  promise: (client: any) =>
    client.get(
      `/facilitadores/monitoring_interest_lots.json?electronic_trading_id=${electronicTradingId}`,
      { params: { companyId } },
    ),
});

export const saveInterestLots = (
  electronicTradingId: number,
  lots: Array<number | null>,
  companyId: number,
) => ({
  types: [
    MonitoringRequestTypes.SAVE_INTEREST_LOTS_REQUEST,
    MonitoringRequestTypes.SAVE_INTEREST_LOTS_SUCCESS,
    MonitoringRequestTypes.SAVE_INTEREST_LOTS_FAILURE,
  ],
  rest: electronicTradingId,
  companyId,
  promise: (client: any) =>
    client.post('/facilitadores/monitoring_interest_lots', {
      electronic_trading_id: electronicTradingId,
      lot: lots,
      companyId,
    }),
});

export const getTradingKeywords = (companyId: number) => ({
  types: [
    MonitoringRequestTypes.GET_TRADING_KEYWORDS_REQUEST,
    MonitoringRequestTypes.GET_TRADING_KEYWORDS_SUCCESS,
    MonitoringRequestTypes.GET_TRADING_KEYWORDS_FAILURE,
  ],
  companyId,
  promise: (client: any) =>
    client.get('/facilitadores/trading_keywords.json', { params: { companyId } }),
});

export const saveTradingKeywords = (tradingKeyword: string, companyId: number) => ({
  types: [
    MonitoringRequestTypes.SAVE_TRADING_KEYWORDS_REQUEST,
    MonitoringRequestTypes.SAVE_TRADING_KEYWORDS_SUCCESS,
    MonitoringRequestTypes.SAVE_TRADING_KEYWORDS_FAILURE,
  ],
  companyId,
  promise: (client: any) =>
    client.post('/facilitadores/trading_keywords', {
      keyword: tradingKeyword,
      companyId,
    }),
});

export const deleteTradingKeyword = (tradingKeywordId: number, companyId: number) => ({
  types: [
    MonitoringRequestTypes.DELETE_TRADING_KEYWORDS_REQUEST,
    MonitoringRequestTypes.DELETE_TRADING_KEYWORDS_SUCCESS,
    MonitoringRequestTypes.DELETE_TRADING_KEYWORDS_FAILURE,
  ],
  companyId,
  promise: (client: any) =>
    client.delete(`facilitadores/trading_keywords/${tradingKeywordId}`, {
      params: { companyId },
    }),
});

export const updateTradingKeyword = (
  tradingKeywordId: number,
  changes: {
    priority?: string;
    notify_sound?: boolean;
    notify_push?: boolean;
    active?: boolean;
  },
  companyId: number,
) => ({
  types: [
    MonitoringRequestTypes.UPDATE_TRADING_KEYWORD_REQUEST,
    MonitoringRequestTypes.UPDATE_TRADING_KEYWORD_SUCCESS,
    MonitoringRequestTypes.UPDATE_TRADING_KEYWORD_FAILURE,
  ],
  companyId,
  promise: (client: any) =>
    client.patch(`/facilitadores/trading_keywords/${tradingKeywordId}`, { ...changes, companyId }),
});

export const markAsRead = (
  electronicTradingId: number,
  lotId: number | null,
  companyId: number,
) => ({
  types: [
    MonitoringRequestTypes.MARK_AS_READ_REQUEST,
    MonitoringRequestTypes.MARK_AS_READ_SUCCESS,
    MonitoringRequestTypes.MARK_AS_READ_FAILURE,
  ],
  rest: electronicTradingId,
  lotId,
  promise: (client: any) =>
    client.patch('/notification/atualiza_todas_como_lidas_new', {
      electronic_trading_id: electronicTradingId,
      lot: lotId,
      companyId,
    }),
});

export const getAppeals = (electronicTradingId: number) => ({
  types: [
    MonitoringRequestTypes.GET_APPEALS_REQUEST,
    MonitoringRequestTypes.GET_APPEALS_SUCCESS,
    MonitoringRequestTypes.GET_APPEALS_FAILURE,
  ],
  rest: electronicTradingId,
  promise: (client: any) =>
    client.get(`/facilitadores/appeals.json?electronic_trading_id=${electronicTradingId}`),
});

export const getAppealsNotifications = (companyId: number) => ({
  types: [
    MonitoringRequestTypes.GET_APPEALS_NOTIFICATIONS_REQUEST,
    MonitoringRequestTypes.GET_APPEALS_NOTIFICATIONS_SUCCESS,
    MonitoringRequestTypes.GET_APPEALS_NOTIFICATIONS_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/notification/new_appeals?read=0`, { params: { companyId } }),
});

export const getNotificationsUnread = (companyId: number) => ({
  types: [
    MonitoringRequestTypes.GET_NOTIFICATIONS_UNREAD_REQUEST,
    MonitoringRequestTypes.GET_NOTIFICATIONS_UNREAD_SUCCESS,
    MonitoringRequestTypes.GET_NOTIFICATIONS_UNREAD_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/notification/new_trading_messages?read=0', { params: { companyId } }),
});

export const markAppealAsRead = (electronicTradingId: number, companyId: number) => ({
  types: [
    MonitoringRequestTypes.MARK_APPEAL_AS_READ_REQUEST,
    MonitoringRequestTypes.MARK_APPEAL_AS_READ_SUCCESS,
    MonitoringRequestTypes.MARK_APPEAL_AS_READ_FAILURE,
  ],
  rest: electronicTradingId,
  promise: (client: any) =>
    client.patch('/notification/atualiza_todas_como_lidas_recurso_new', {
      electronic_trading_id: electronicTradingId,
      notification_type: 'Notification::NewAppeal',
      companyId,
    }),
});

export const toggleImportant = (bidding_id: number, company_id: number) => ({
  types: [
    MonitoringRequestTypes.TOGGLE_IMPORTANT_REQUEST,
    MonitoringRequestTypes.TOGGLE_IMPORTANT_SUCCESS,
    MonitoringRequestTypes.TOGGLE_IMPORTANT_FAILURE,
  ],
  biddingId: bidding_id,
  companyId: company_id,
  promise: (client: any) =>
    client.patch(`/facilitadores/electronics_trading/${bidding_id}/toggle_important`, {
      companyId: company_id,
    }),
});

export const archive = (bidding_id: number, companyId: number, ContactClienteId: number) => ({
  types: [
    MonitoringRequestTypes.ARCHIVE_REQUEST,
    MonitoringRequestTypes.ARCHIVE_SUCCESS,
    MonitoringRequestTypes.ARCHIVE_FAILURE,
  ],
  biddingId: bidding_id,
  companyId,
  promise: (client: any) =>
    client.patch('/facilitadores/electronics_trading/archive', {
      bidding_id,
      companyId,
      ContactClienteId,
    }),
});

export const getMonitoredElectronicTradingIds = () => ({
  types: [
    MonitoringRequestTypes.GET_MONITORED_ELECTRONIC_TRADING_IDS_REQUEST,
    MonitoringRequestTypes.GET_MONITORED_ELECTRONIC_TRADING_IDS_SUCCESS,
    MonitoringRequestTypes.GET_MONITORED_ELECTRONIC_TRADING_IDS_FAILURE,
  ],
  promise: (client: any) => client.get('/facilitadores/electronics_trading_represented'),
});
